import React, { useState } from "react";
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap";
import Select from "react-select";

const SelectDocumentsStep = ({ documentDescriptors, onNext }) => {
    const [selectedDocuments, setSelectedDocuments] = useState([]);

    const handleChange = selectedOptions => {
        setSelectedDocuments(selectedOptions || []);
    };

    const handleNext = () => {
        if (selectedDocuments.length > 0) {
            onNext(selectedDocuments);
        } else {
            alert("Debes seleccionar al menos un documento.");
        }
    };

    return (
        <Row>
            <Col md="12">
                <Card className="mb-4 material-shadow">
                    <CardBody>
                        <h4 className="h4 mb-3">Seleccionar Documentos</h4>
                        <Label>Selecciona los documentos que deseas cargar:</Label>
                        <Select
                            isMulti
                            options={documentDescriptors.map(desc => ({
                                value: desc.id,
                                label: desc.name
                            }))}
                            onChange={handleChange}
                            placeholder="Selecciona uno o más documentos..."
                        />
                        <div className="text-right mt-3">
                            <Button color="primary" onClick={handleNext}>Continuar</Button>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default SelectDocumentsStep;
